function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null);

var _ref3 = /*#__PURE__*/React.createElement("g", null);

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

function Svg081CookIslands(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Capa_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 0.002,
    y: 0.002,
    style: {
      fill: "#2E52B2"
    },
    width: 511.998,
    height: 511.998
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "383.998,156.706 389.281,172.96 406.37,172.96 392.544,183.005 397.826,199.258    383.998,189.213 370.173,199.258 375.454,183.005 361.629,172.96 378.717,172.96  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "313.79,185.787 329.018,193.546 341.102,181.462 338.428,198.342 353.656,206.1    336.777,208.773 334.103,225.654 326.343,210.426 309.465,213.099 321.55,201.016  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "284.709,255.996 300.962,250.715 300.963,233.627 311.007,247.451 327.261,242.169    317.216,255.996 327.261,269.823 311.007,264.541 300.963,278.368 300.963,261.278  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "313.79,326.204 321.549,310.975 309.465,298.892 326.345,301.566 334.103,286.339    336.777,303.217 353.656,305.89 338.428,313.65 341.102,330.53 329.018,318.444  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "383.998,355.285 378.717,339.032 361.626,339.032 375.454,328.986 370.173,312.733    383.998,322.777 397.826,312.733 392.544,328.986 406.37,339.032 389.281,339.032  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "454.207,326.204 438.978,318.447 426.895,330.53 429.568,313.65 414.341,305.892    431.22,303.217 433.895,286.339 441.652,301.566 458.532,298.892 446.446,310.977  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "483.288,255.996 467.034,261.278 467.034,278.368 456.989,264.54 440.736,269.823    450.781,255.996 440.736,242.169 456.989,247.451 467.034,233.627 467.034,250.715  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "454.207,185.788 446.45,201.016 458.532,213.099 441.652,210.426 433.895,225.654    431.22,208.773 414.341,206.099 429.568,198.342 426.895,181.463 438.979,193.546  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "255.999,0 255.999,48.896 215.852,89.043 255.999,89.043 255.999,166.956 203.463,166.956    255.999,219.491 255.999,255.999 232.28,255.999 166.956,190.664 166.956,255.999 89.043,255.999 89.043,178.275 11.331,255.999    0,255.999 0,207.103 40.147,166.956 0,166.956 0,89.043 52.535,89.043 0,36.508 0,0 23.719,0 89.043,65.335 89.043,0 166.956,0    166.956,77.723 244.668,0  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "0,152 104,152 104,255.999 152,255.999 152,152 255.999,152 255.999,104 152,104 152,0   104,0 104,104 0,104 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "166.956,166.956 255.999,255.999 255.999,230.819 192.136,166.956  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "63.862,166.958 0,230.82 0,255.999 0,255.999 89.041,166.958  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#0052B4"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F0F0F0"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043 "
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "89.043,89.043 0,0 0,25.18 63.863,89.043  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D80027"
    },
    points: "192.137,89.041 255.999,25.179 255.999,0 255.999,0 166.958,89.041  "
  })), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg081CookIslands);
export default "data:image/svg+xml;base64,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";
export { ForwardRef as ReactComponent };